import { useContext, useEffect } from 'react';
import ShopContext from '^/ShopContext';
import * as uf from '%/functions';
const RefineBy = () => {


  const {
    selectedFilters,
    addRemoveSelectedFilter,
    resetSelectedFilters,
  } = useContext(ShopContext);

  const list = Object.entries(selectedFilters).reduce((acc, [name, obj]) => {
    Object.keys(obj).forEach(description => selectedFilters[name][description] && acc.push({ name, description }))
    return acc;
  }, [])

  
  if (!list.length)
    return <></>

    // console.log(uf.jsonToArray(selectedFilters));

  return (
    <div id="siderefineFilters" class="sidebarBlock accordion-block sidebarEffects-widnow ss-summary ss-targeted ng-scope" ng-if="filterSummary.length">
      <div class="accordion-navigation toggleLink is-open ng-scope" ng-if="!slideout.triggered">
        <h5 class="accordion-title side-module-heading">			Refine by		</h5>
        <div class="accordion-navigation-actions">
          <i class="fa fa-chevron-up accordion-indicator toggleLink-text toggleLink-text--off"></i>			<i class="fa fa-chevron-down accordion-indicator toggleLink-text toggleLink-text--on"></i>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column'
        }}
        id="facetedSearch-content--refineFilters" class="accordion-content is-open">
        <ul class="inlineList inlineList--labels">
          {list.map(each =>
            <li
              onClick={() => {
             
                addRemoveSelectedFilter(each, 'remove')
              }}
              class="refine-filter-item">
              <a class="facetLabel cursor-ptr" >{each.description}
                <span style={{ marginLeft: 8, fontSize: 12 }}>X</span>
              </a>
            </li>
          )}
        </ul>
        <a class="ss-list-link"
          style={{
            marginLeft: 24
          }}
          onClick={() => {resetSelectedFilters(); initializeResults()}}
        >			Clear all		</a>
      </div>
    </div>
  )
}
export default RefineBy;